const impuestos = [
  "Nacionales y Provinciales",
  "Asesoramiento y liquidación",
  "Moratorias y planes de facilidades de pago",
  "Inscripciones y bajas ante los organismos de control",
  "Tramitación de exenciones",
  "Atención a inspecciones y requerimientos",
];
const contabilidad = [
  "Armado de estados contables",
  "Reportes gerenciales",
  "Control de registraciones",
  "Outsourcing de contabilidad",
  "Libros obligatorios y auxiliares",
  "Certificaciones varias",
];
const laboral = [
  "Inscripción de empleadores",
  "Altas y bajas de empleados",
  "Liquidación de sueldos, jornales y cargas sociales",
  "Liquidación de impuesto a las ganancias 4ta categoría",
  "Certificaciones de servicios",
  "Atención a inspecciones y requerimientos",
];

const sociedades = [
  "Atención a inspecciones y requerimientos",
  "Rúbrica y teneduría de libros societarios",
];

export { impuestos, contabilidad, laboral, sociedades };
